module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('apexchart', {
    attrs: {
      "type": _vm.chartType,
      "height": _vm.chartHeight,
      "options": _vm.apexOptions,
      "series": _vm.apexSeries
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e96d57a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/ClientTeusBarChart.vue
// module id = 2547
// module chunks = 0